class SearchResults extends HTMLElement {
    constructor() {
        super();
        this.inputValue = '';
        this.selectedCollection = '';
        this.dataList = this.getAttribute('data-list');

        if (this.applyLockedFilter()) return;

        this.init();
        this.hideResultsNotInUserCatalog();
    }

    // Prefilter results by the product type chosen in the search form
    applyLockedFilter() {
        const param = this.dataset.lockedFilterParam;
        const value = this.dataset.lockedFilterValue;
        if (!param || !value) return false;
        const url = new URL(location.href);
        if (url.searchParams.getAll(param).includes(value)) return false;
        url.searchParams.set(param, value);
        location.replace(url.toString());
        return true;
    }

    hideResultsNotInUserCatalog() {
        if (this.dataList == 'catalogo') {
            const menuBar = document.querySelector('menu-bar');
            const selectedCustomer = localStorage.getItem('errea_selectedCustomer')
                ? JSON.parse(localStorage.getItem('errea_selectedCustomer'))
                : null;
            if (menuBar && selectedCustomer) {
                let collectionsSelected = menuBar.collectionsToShow;
                if (window.errea_accountUserData.accountType != 'Customer' && collectionsSelected) {
                    const foundCollectionView = collectionsSelected.find(
                        (connection) => connection.id_connection == selectedCustomer.customerNo,
                    );
                    if (foundCollectionView) {
                        collectionsSelected = foundCollectionView.collections;
                    } else {
                        collectionsSelected = null;
                    }
                }
                if (collectionsSelected) {
                    const productsRow = this.querySelectorAll('product-list-element');
                    if (productsRow) {
                        productsRow.forEach((row) => {
                            const collectionReference =
                                row.querySelector('.variant .recap input[name="productCollectionHandle"]') ?? null;
                            if (collectionReference) {
                                const foundReference = collectionsSelected.find(
                                    (collection) => collection.handle == collectionReference.value,
                                );
                                if (!foundReference) {
                                    const productListElement =
                                        collectionReference.parentNode.parentNode.parentNode.parentNode.parentNode
                                            .parentNode.parentNode;
                                    if (productListElement) {
                                        productListElement.remove();
                                    }
                                }
                            }
                        });
                    }
                    const productGrid = this.querySelectorAll('#product-grid li.grid__item');
                    if (productGrid.length == 0) {
                        this.showNoResultsMessage();
                    }
                }
            }
        } else {
            const productGrid = this.querySelectorAll('#product-grid .errea-product_list_item');
            if (productGrid.length == 0) {
                this.showNoResultsMessage();
            }
        }
    }

    showNoResultsMessage() {
        const message = document.getElementById('product-grid-no-items');
        message.style.display = 'block';
    }

    async init() {
        const parameters = getParamsFromUrl(location.search.replace('?', ''));
        if (parameters.q && parameters.collection) {
            this.inputValue = parameters.q;
            this.selectedCollection = parameters.collection;
            const resultString = document.querySelector('h1 span');
            if (resultString) {
                const decodedQuery = decodeURIComponent(parameters.q.replace(/\+/g, ' '));
                const searchType = parameters.search_type || (parameters.type != 'product' ? parameters.type : parameters.collection == 'catalogo' ? 'catalogo' : '');
                const typeSuffix = searchType ? ` ${searchType}` : '';
                const queryWithoutType = typeSuffix && decodedQuery.endsWith(typeSuffix)
                    ? decodedQuery.slice(0, -typeSuffix.length)
                    : decodedQuery;
                const termSearched = queryWithoutType.replace(/ OR sku:.*\*$/, '').replace(/\*.*$/, '').replace(/^"(.*)"$/, '$1').trim();
                resultString.innerText = termSearched;
                document.title = `${window.searchStrings.title}: ${termSearched}`;
            }
        }
    }
}

customElements.define('search-results', SearchResults);
